const serverUrl = process.env.REACT_APP_API_URL || "http://localhost:1337";

const authProvider = {
  login: ({ username, password }) => {
    const identifier = username;
    const request = new Request(`${serverUrl}/admin/auth/local`, {
      method: "POST",
      body: JSON.stringify({ identifier, password }),
      headers: new Headers({ "Content-Type": "application/json" }),
    });
    return fetch(request)
      .then((response) => {
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then((response) => {
        localStorage.setItem("token", response.jwt);
      });
  },

  logout: () => {
    localStorage.clear();
    return Promise.resolve();
  },

  checkAuth: () => {
    return localStorage.getItem("token") ? Promise.resolve() : Promise.reject();
  },

  checkError: ({ status }) => {
    if (status === 401 || status === 403) {
      localStorage.clear();
      return Promise.reject();
    }
    return Promise.resolve();
  },

  getPermissions: () => {
    return Promise.resolve("admin");
  },
};

export default authProvider;
